// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bgnew[data-v-04321ec4]{background:#2ea18b}.text-blue[data-v-04321ec4]{color:#309db6}.fi[data-v-04321ec4]{width:1.5em;height:1.5em}.navbar[data-v-04321ec4]{min-height:4rem}@media screen and (min-width:1024px){.navbar[data-v-04321ec4]{min-height:5rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
